<!-- 标记 -->
<template>
    <modal :visible.sync="isShowDialog" :title="dialogTitle"  width="450px" @close="close">
      <el-form ref="form" label-width="80px" style="padding: 10px 30px">
        <el-form-item prop="type" :label="$t('integration.sign_as')">
          <el-select v-model="type">
            <el-option
              v-for="item in invalidMsg"
              :key="item.value"
              :label="$t(item.label)"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="close">{{ $t('public.btn_close') }}</el-button>
        <el-button type="primary" @click="handleSave">{{ $t('public.btn_confirm') }}</el-button>
      </div>
    </modal>
</template>
<script>
import { invalidMsg } from '@/utils/convert.js'
import { markExRecord } from '@/api/modules/abnormal.js'

export default {
  name: 'RemarkDialog',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    exId: {
      type: String,
      default: null,
    },
    excludeStatus: {
      type: Number,
      default: null,
    },
    carrierName: {
      type: String,
      default: '',
    },
    carrierDeviceName: {
      type: String,
      default: '',
    },
    batch: {
      type: Boolean,
      default: false,
    },
    exIds: {
      type: Array,
      default: () => [],
    }
  },

  data () {
    return {
      invalidMsg,
      type: null,
    }
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    },
    dialogTitle () {
      if (this.batch) {
        return this.$t('integration.ir_status')
      }
      return `${this.carrierName || ''} ${this.carrierDeviceName || ''} ${this.$t('integration.log')} ${this.$t('integration.ir_status')}`
    }
  },
  watch: {
    isShowDialog(){
      if(this.isShowDialog){
      }
    }
  },
  created(){
    // 将excludeStatus的格式转换一下
    if(this.excludeStatus === 0){
      this.type = 'normal'
    }else if(this.excludeStatus === 1){
      this.type = 'abnormal'
    }else if(this.excludeStatus === 2){
      this.type = 'suspecte'
    }else{
      this.type = null
    }

  },
  methods: {
    close(){
      this.type = null
      this.$emit('close')
    },
    async handleSave(){
      if(!this.type){
        this.$message.warning(this.$t('public.please'))
        return
      }
      if (this.batch) {
        // 批量操作
        try {
          for (const id of this.exIds) {
            await markExRecord(this.type, id)
          }
          this.$message.success($t('integration.success'))
          this.close()
          this.$parent.getList()
        } catch (e) {
          this.$message.error($t('integration.operation_failed'))
        }
      } else {
        markExRecord(this.type, this.exId).then(({state}) => {
          if (state.code === 200) {
            this.$message.success($t('integration.success'))
            this.close()
            this.$parent.getList()
          }
        })
      }
    }
  }
}
</script>
